export enum EventCategory {
    Normal, // 普通事件
    Cricket, // 板球
    Basketball, // 篮球
    Football, // 足球
    Crypto = 5, // 虚拟货币
}

/** 体育赛事分类列表 */
const SPORT_CATEGORIES = [
    EventCategory.Cricket,
    EventCategory.Basketball,
    EventCategory.Football,
];

/**
 * 判断是否为体育赛事
 * @param eventCategory 事件分类
 */
export const isSportCategory = ( eventCategory: EventCategory ): boolean => {
    return SPORT_CATEGORIES.includes( eventCategory );
};
